import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as platform from 'platform';
import ImmutablePropTypes from 'react-immutable-proptypes';
import first from 'lodash/first';
import { Button, CloseButton } from '@instructure/ui-buttons';
import { Heading } from '@instructure/ui-heading';
import t from '@instructure/quiz-i18n/es/format-message';
import InteractionTypes from '../../../common/components/shared/InteractionTypes';
import { XSMALL_SIDE_MARGIN, Modal, ModalHeader, ModalBody, ModalFooter } from '@instructure/quiz-common';
export var AddBankEntryModal = /*#__PURE__*/function (_Component) {
  function AddBankEntryModal() {
    var _this;
    _classCallCheck(this, AddBankEntryModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AddBankEntryModal, [].concat(args));
    _defineProperty(_this, "addItem", function (interactionTypeData) {
      var defaultInteractionData = interactionTypeData.getDefaultInteractionData();
      var scoringData = interactionTypeData.getDefaultScoringData(defaultInteractionData);
      var itemProps = {
        id: interactionTypeData.id,
        interactionData: defaultInteractionData,
        itemBody: interactionTypeData.itemBody,
        properties: interactionTypeData.defaultProperties,
        scoringAlgorithm: interactionTypeData.scoringAlgorithmDefault,
        scoringData: scoringData,
        userResponseType: first(interactionTypeData.userResponseTypeOptions)
      };
      _this.props.createBankItem(_this.props.bankId, 'Item', itemProps);
      _this.closeAction();
      _this.props.navigateToBankEntry('new', _this.props.bankId);
    });
    _defineProperty(_this, "addStimulus", function () {
      _this.props.createBankItem(_this.props.bankId, 'Stimulus');
      _this.closeAction();
      _this.props.navigateToBankEntry('new', _this.props.bankId);
    });
    _defineProperty(_this, "closeAction", function () {
      if (_this.props.modalTrigger) {
        _this.props.modalTrigger.focus();
      }
      _this.props.closeModal();
    });
    return _this;
  }
  _inherits(AddBankEntryModal, _Component);
  return _createClass(AddBankEntryModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getInteractionTypes();
    }
  }, {
    key: "cancelButton",
    value: function cancelButton() {
      return /*#__PURE__*/React.createElement(Button, {
        onClick: this.closeAction,
        margin: XSMALL_SIDE_MARGIN
      }, t('Close'));
    }
  }, {
    key: "render",
    value: function render() {
      // For some reason, there's obscure behavior on IE11 that makes Modal size='auto'
      // behave poorly with instui Grid; see https://instructure.atlassian.net/browse/QUIZ-4100.
      // This is just a simple workaround.
      var size = platform.name === 'IE' && platform.version === '11.0' ? 'medium' : 'auto';
      return /*#__PURE__*/React.createElement(Modal, {
        open: this.props.modalOpen,
        onDismiss: this.closeAction,
        size: size,
        label: t('New Item')
      }, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(Heading, {
        level: "reset",
        as: "h2"
      }, t('New Item')), /*#__PURE__*/React.createElement(CloseButton, {
        onClick: this.closeAction,
        placement: "end",
        offset: "medium",
        screenReaderLabel: t('Close')
      })), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(InteractionTypes, {
        columns: 3,
        addItem: this.addItem,
        addStimulus: this.addStimulus,
        allowStimulusCreation: true,
        types: this.props.interactionTypes
      })), /*#__PURE__*/React.createElement(ModalFooter, null, this.cancelButton()));
    }
  }]);
}(Component);
_defineProperty(AddBankEntryModal, "propTypes", {
  modalOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  modalTrigger: PropTypes.instanceOf(Component),
  createBankItem: PropTypes.func.isRequired,
  navigateToBankEntry: PropTypes.func.isRequired,
  bankId: PropTypes.string.isRequired,
  getInteractionTypes: PropTypes.func.isRequired,
  interactionTypes: ImmutablePropTypes.list.isRequired
});
_defineProperty(AddBankEntryModal, "defaultProps", {
  modalTrigger: null
});
export default AddBankEntryModal;